import React, { Component } from 'react'
import TextField from "@material-ui/core/TextField";
class EditNicknameField extends Component {
    constructor(props) {
        super()

        this.state = {
            nickname: props.nickname,
        };
    }
    componentDidMount = () => {
        document.addEventListener("keydown", this.checkKey);
    }

    componentWillUnmount = () => {
        document.removeEventListener("keydown", this.checkKey)
    }

    checkKey = (e) => {
        if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
        e.preventDefault()
            this.props.renameDevice(this.state.nickname)
        }
    }

    updateName = (e) => {
        this.setState({
            nickname: e.currentTarget.value,
        });
    }

    renderErrors = (error) => {
        return (
            <ul className="flex-centered shake-on-error" id="form-errors">
                {error}
            </ul>
        );
    }

    render() {
        return (
            <form noValidate autoComplete="off" onClick={() => this.setState(prevState => ({ editingDeviceName: !prevState.editingDeviceName }))}>
                <TextField id="standard-basic" 
                    onChange={this.updateName}
                    // label={"Edit Nickname"} 
                    defaultValue={this.state.nickname} />
            </form>
        )
    }
}
export default EditNicknameField